export default __webpack_public_path__ + "static/media/ico-ideaastra-400x300px-yellow.b16c6069.png";